import React from 'react'
import style from './forms.mod.scss'
import { Input, Textarea, Checkbox, Button } from '@components'

const FormsDitchTheScales = ({ inputs, onSubmit, isSubmitting }) => {
  const handleSubmit = e => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = Object.fromEntries(formData.entries())
    onSubmit(data)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={style.form__double}>
        <Input
          type="text"
          label="First Name"
          placeholder="Enter first name"
          name="firstName"
          required
        />
        <Input
          type="text"
          label="Last Name"
          placeholder="Enter last name"
          name="lastName"
          required
        />
      </div>
      <Input
        type="email"
        label="Email Address (associated with your DediKate membership)"
        placeholder="Enter your email address"
        name="email"
        required
        ref={inputs.emailAddress}
      />
      <Textarea
        label="Your Story"
        placeholder="How you've ditched the scales and your journey so far…"
        required
        name="message"
      />
      <Checkbox
        required
        label="I confirm that I am an active DediKate member."
      />
      <div className={style.form__submit}>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit Story'}
        </Button>
      </div>
    </form>
  )
}

export default FormsDitchTheScales
